import { createSlice } from "@reduxjs/toolkit"

import { LanguageChatResponse } from "types/api"
import { ASSISTANT_MAPPING, LANGUAGE_INTERVIEW_STAGES } from "utils/constants"

interface LanguageJudgeState {
  languageInterviewStage: string
  interviewLanguageSlug: string | null
  sessionId: string | null
  isInterviewFinished: boolean
  responseText: string | null
  botResponse: LanguageChatResponse | null
  isUserSpeaking: boolean
  editorValue: string | null
  language: string | null
  cooldownTimer: string | Number | Date | null
  isSocketLoading: boolean
  response: string
  wordCurrentIndex: number
  isGeneratingResponse: boolean
  isSocketDisconnected: boolean
}

const initialState: LanguageJudgeState = {
  languageInterviewStage: LANGUAGE_INTERVIEW_STAGES.initialize,
  interviewLanguageSlug: ASSISTANT_MAPPING.java,
  sessionId: null,
  isInterviewFinished: false,
  responseText: null,
  botResponse: null,
  isUserSpeaking: false,
  editorValue: null,
  language: null,
  cooldownTimer: null,
  isSocketLoading: true,
  response: "",
  wordCurrentIndex: 0,
  isGeneratingResponse: false,
  isSocketDisconnected: false,
}

const languageJudgeStore = createSlice({
  name: "language_judge",
  initialState: initialState,
  reducers: {
    setLanguageInterviewStages: (state, action) => {
      state.languageInterviewStage = action.payload
    },
    setInterviewLanguageSlug: (state, action) => {
      state.interviewLanguageSlug = action.payload
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload
    },
    setIsInterviewFinish: (state, action) => {
      state.isInterviewFinished = action.payload
    },
    setResponseText: (state, action) => {
      state.responseText = action.payload
    },
    setBotResponse: (state, action) => {
      state.botResponse = action.payload
    },
    setIsUserSpeaking: (state, action) => {
      state.isUserSpeaking = action.payload
    },
    setEditorValue: (state, action) => {
      state.editorValue = action.payload
    },
    setLanguage: (state, action) => {
      state.language = action.payload
    },
    setCooldownTimer: (state, action) => {
      state.cooldownTimer = action.payload
    },
    setIsSocketLoading: (state, action) => {
      state.isSocketLoading = action.payload
    },
    appendResponseText: (state, action) => ({
      ...state,
      response: state.response + " " + action.payload,
    }),
    setClearResponse: (state) => ({
      ...state,
      response: "",
    }),
    setLanguageCurrentWordIndex: (state, action) => {
      state.wordCurrentIndex = action.payload
    },
    setIsGeneratingResponse: (state, action) => {
      state.isGeneratingResponse = action.payload
    },
    setIsSocketDisconnected: (state, action) => {
      state.isSocketDisconnected = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  setLanguageInterviewStages,
  setInterviewLanguageSlug,
  setSessionId,
  setIsInterviewFinish,
  setResponseText,
  setBotResponse,
  setIsUserSpeaking,
  setEditorValue,
  setLanguage,
  setCooldownTimer,
  setIsSocketLoading,
  appendResponseText,
  setClearResponse,
  setLanguageCurrentWordIndex,
  setIsGeneratingResponse,
  setIsSocketDisconnected,
  resetState,
} = languageJudgeStore.actions

export default languageJudgeStore.reducer
